import InstitutionState from "@/models/Settings/Institutions/InstitutionState";

export default (val: InstitutionState) => {
    let returnVal = "Undefined";
    switch (val) {
        case InstitutionState.Enabled:
            returnVal = "Enabled"
            break;
        case InstitutionState.Disabled:
            returnVal = "Disabled"
            break;
    }
    return returnVal;
}